"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sentry = _interopRequireDefault(require("@spothero/utils/sentry"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var ErrorBoundary =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ErrorBoundary, _Component);

  function ErrorBoundary() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ErrorBoundary)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      error: null
    });
    return _this;
  }

  (0, _createClass2.default)(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      var _this$props = this.props,
          reportToSentry = _this$props.reportToSentry,
          onError = _this$props.onError;
      this.setState({
        error: error
      });

      if (onError) {
        onError(error, info);
      }

      if (reportToSentry) {
        _sentry.default.addData(info);

        _sentry.default.sendMessage({
          message: error.message,
          level: 'error'
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          errorComponent = _this$props2.errorComponent;
      var error = this.state.error;
      var classes = (0, _classnames.default)('ErrorBoundary', className);

      if (error) {
        return _react.default.createElement("div", {
          className: classes
        }, errorComponent, !errorComponent && _react.default.createElement("div", {
          className: "ErrorBoundary-content"
        }, _react.default.createElement("div", {
          className: "ErrorBoundary-info"
        }, "An error has occurred."), _react.default.createElement("div", {
          className: "ErrorBoundary-info"
        }, "Please refresh the page and try again.")));
      }

      return children;
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return ErrorBoundary;
}(_react.Component);

exports.default = ErrorBoundary;
(0, _defineProperty2.default)(ErrorBoundary, "propTypes", {
  /** Additional class(es) to add to the component -- only shows on error catch. */
  className: _propTypes.default.string,

  /** The node to display when the component does not have any errors. */
  children: _propTypes.default.node.isRequired,

  /** A custom node to display in place of the default error messaging. */
  errorComponent: _propTypes.default.element,

  /** Whether or not to report error to Sentry. */
  reportToSentry: _propTypes.default.bool,

  /**
   * Function to execute when the an error is caught.
   *
   * @param {Object} error - The error object.
   * @param {Object} info - Extra info provided by React.
   */
  onError: _propTypes.default.func
});
(0, _defineProperty2.default)(ErrorBoundary, "defaultProps", {
  reportToSentry: true
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ErrorBoundary, "ErrorBoundary", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/ErrorBoundary/ErrorBoundary.jsx");
  leaveModule(module);
})();

;